module.exports = __webpack_public_path__ + "img/IMG_2515-2.aae9ca0d.jpg";